<template>
  <div class="app flex-row align-items-center" id="login-page">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8" lg="5">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <div class="text-center padding-bottom-20">
                  <img src="img/login-03-logo.png" alt />
                </div>
                <h3 class="text-center">{{ aLang.login }}</h3>
                <b-alert
                  variant="danger"
                  dismissible
                  :show="mData.dataDefault.showDismissibleAlert"
                  @dismissed="mData.dataDefault.showDismissibleAlert = false"
                  >{{ mData.dataDefault.error }}</b-alert
                >

                <el-form
                  :model="mData.dataForm"
                  :rules="mData.validForm"
                  ref="myForm"
                  label-width="100%"
                  label-position="top"
                  @submit.native.prevent
                >
                  <div v-if="mData.name && mData.dataDefault.actived">
                    <p style="text-align: center; margin-bottom: 10px">
                      Xin chào bạn!
                    </p>
                    <p
                      style="
                        text-align: center;
                        font-size: 16px;
                        font-weight: bold;
                      "
                    >
                      {{ mData.name }}
                    </p>
                  </div>

                  <el-form-item
                    :label="
                      !mData.dataDefault.isDoctor
                        ? aLang.login_account_victim
                        : aLang.login_account
                    "
                    prop="account"
                    v-show="!mData.name || !mData.dataDefault.actived"
                  >
                    <b-row v-show="!mData.dataDefault.isDoctor">
                      <b-col md="4">
                        <el-form-item label="" prop="1">
                          <!-- <el-input v-model="mData.dataForm.ThongTinHanhChinh.NHOM_MAU" clearable></el-input> -->
                          <el-radio
                            v-model="mData.dataDefault.typeAccountUser"
                            label="1"
                            style="margin-right: 10px"
                            @change="fn_changeTypeAccountUser()"
                            >Số thẻ khám chữa bệnh</el-radio
                          >
                          <el-radio
                            v-model="mData.dataDefault.typeAccountUser"
                            label="2"
                            style="margin-right: 10px"
                            @change="fn_changeTypeAccountUser()"
                            >Số CMND/CCCD</el-radio
                          >
                          <el-radio
                            v-model="mData.dataDefault.typeAccountUser"
                            label="3"
                            style="margin-right: 10px"
                            @change="fn_changeTypeAccountUser()"
                            >Số điện thoại di động</el-radio
                          >
                          <el-radio
                            v-model="mData.dataDefault.typeAccountUser"
                            label="4"
                            @change="fn_changeTypeAccountUser()"
                            >10 số cuối BHYT</el-radio
                          >
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <el-input
                      prefix-icon="el-icon-user"
                      v-model.trim="mData.dataForm.accountFormat"
                      :disabled="
                        mData.dataDefault.actived &&
                        !mData.dataDefault.isDoctor &&
                        mData.dataDefault.typeAccount != 'hospital'
                      "
                      :placeholder="
                        !mData.dataDefault.isDoctor //? 'Nhập số thẻ khám chữa bệnh'
                          ? mData.dataDefault.TextPlaceHolder
                          : ''
                      "
                      ref="accountInput"
                      clearable
                      autofocus
                      :maxlength="
                        !mData.dataDefault.isDoctor
                          ? mData.dataDefault.maxLengthAccountUser
                          : 100
                      "
                      @input="fn_changeDataAccountUser()"
                    ></el-input>
                  </el-form-item>

                  <el-form-item
                    v-show="
                      mData.dataDefault.isDoctor || mData.dataDefault.actived
                    "
                    :label="aLang.login_password"
                    prop="password"
                  >
                    <el-input
                      prefix-icon="el-icon-unlock"
                      v-model.trim="mData.dataForm.password"
                      show-password
                      ref="passwordInput"
                      autofocus
                    ></el-input>
                    <el-link
                      type="primary"
                      :underline="false"
                      style="
                        position: absolute;
                        right: 0;
                        top: 100%;
                        color: #009ad0;
                      "
                      @click="fn_forgotPassword"
                      v-show="
                        mData.dataDefault.actived &&
                        mData.dataDefault.typeAccount == 'victim'
                      "
                      >{{ aLang.login_forgot_password }}</el-link
                    >
                  </el-form-item>

                  <div
                    class="d-flex flex-wrap justify-content-start mb-3"
                    v-bind:class="{
                      'mt-5':
                        mData.dataDefault.actived &&
                        mData.dataDefault.typeAccount == 'victim',
                    }"
                  >
                    <div class="justify-content-start mr-5">
                      <el-form-item label prop="remember" style="margin: 0">
                        <el-checkbox v-model="mData.dataForm.remember">
                          <span class="color-dark">{{
                            aLang.login_remember
                          }}</span>
                        </el-checkbox>
                      </el-form-item>
                    </div>
                    <div v-show="mData.dataDefault.typeAccount != 'hospital'">
                      <el-form-item label style="margin: 0">
                        <el-checkbox
                          v-model="mData.dataDefault.isDoctor"
                          @change="fn_resetForm"
                        >
                          <span class="bold-500 color-primary"
                            >Bác sỹ trạm</span
                          >
                        </el-checkbox>
                      </el-form-item>
                    </div>
                  </div>

                  <el-form-item class="text-center">
                    <el-button
                      type="primary"
                      @click="fn_submitForm()"
                      v-ladda
                      native-type="submit"
                      >{{
                        !mData.dataDefault.isDoctor &&
                        !mData.dataDefault.actived
                          ? aLang.login_next
                          : aLang.login
                      }}</el-button
                    >
                    <el-button
                      v-show="
                        mData.dataDefault.actived &&
                        mData.dataDefault.typeAccount != 'hospital'
                      "
                      type="primary"
                      @click="fn_changeAccount()"
                      v-ladda
                      native-type="submit"
                      >{{ aLang.login_change_account }}</el-button
                    >
                  </el-form-item>
                </el-form>
                <!-- <p style="fontSize:14px">Tài liệu hướng dẫn sử dụng</p> -->
                <div class="text-left color-primary">
                  <span style="float: left"
                    >Hướng dẫn sử dụng cho người dân</span
                  >
                  <a
                    target="_blank"
                    href="/tailieu/huong_dan_su_dung_hssk_cho_nguoi_dan_web.pdf"
                    class="link bold-500 ml-2"
                    style="
                      padding-left: 20px;
                      position: relative;
                      display: block;
                      float: left;
                    "
                  >
                    <i
                      class="icon-screen-desktop"
                      style="
                        position: absolute;
                        left: 0;
                        top: 50%;
                        transform: translate(0, -50%);
                      "
                    ></i>
                    Web
                  </a>
                  <a
                    target="_blank"
                    href="/tailieu/huong_dan_su_dung_hssk_cho_nguoi_dan_mobie.pdf"
                    class="link bold-500 ml-2"
                    style="
                      padding-left: 20px;
                      position: relative;
                      display: block;
                      float: left;
                    "
                  >
                    <i
                      class="icon-screen-smartphone"
                      style="
                        position: absolute;
                        left: 0;
                        top: 50%;
                        transform: translate(0, -50%);
                      "
                    ></i>
                    Mobile
                  </a>
                </div>
                <div class="text-left color-primary" style="clear: both">
                  <a
                    target="_blank"
                    href="/tailieu/huong_dan_ung_dung_HSSK_cho_bac_si.pdf"
                    class="link bold-500"
                    >Hướng dẫn sử dụng cho bác sĩ</a
                  >
                </div>
                <div class="text-left color-primary">
                  <a
                    target="_blank"
                    href="/tailieu/cong_tac_chuan_bi_trien_khai_HSSK_dien_tu_cua_1_tinh.pdf"
                    class="link bold-500"
                    >Hướng dẫn tổng thể triển khai HSSK cho 1 tỉnh</a
                  >
                </div>
                <div class="text-left color-primary">
                  <a
                    target="_blank"
                    href="/tailieu/cong_tac_chuan_bi_trien_khai_HSSK_dien_tu_cho_CSKCB.pdf"
                    class="link bold-500"
                    >Hướng dẫn tổng thể triển khai HSSK cho CSKCB</a
                  >
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>

    <!-- popup nhập otp -->
    <div
      v-show="mData.dataDefault.activeVisible"
      style="
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 100;
      "
    >
      <div
        style="
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          background-color: rgba(56, 30, 30, 0.58);
        "
      ></div>
      <div
        style="
          width: calc(100% - 2rem);
          max-width: 445px;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          background-color: white;
          padding: 1rem;
          border-radius: 3px;
          box-shadow: 3px 6px 6px 0px rgba(0, 0, 0, 0.75);
        "
      >
        <h3>{{ aLang.login_active_title }}</h3>
        <b-alert
          variant="danger"
          dismissible
          :show="mData.dataDefault.showErrorActive"
          @dismissed="mData.dataDefault.showErrorActive = false"
          >{{ mData.dataDefault.errorActive }}</b-alert
        >
        <el-form
          :model="mData.activeForm"
          :rules="mData.validActiveForm"
          ref="activeForm"
          label-width="100%"
          label-position="top"
          @submit.native.prevent
        >
          <el-form-item :label="aLang.login_phone" prop="phoneNumber">
            <el-input
              prefix-icon="el-icon-phone"
              v-model.trim="mData.activeForm.phoneNumber"
              clearable
              style="width: calc(100% - 105px)"
              :disabled="mData.dataDefault.disabledPhoneNumber"
              @input="fn_changeData('activeForm', 'phoneNumber')"
            ></el-input>
            <el-button
              type="primary"
              @click="fn_getOTP"
              style="float: right"
              v-ladda
              native-type="submit"
              >{{ aLang.login_get_otp }}</el-button
            >
          </el-form-item>
          <el-form-item :label="aLang.login_otp" prop="otp">
            <el-input
              prefix-icon="el-icon-eleme"
              v-model.trim="mData.activeForm.otp"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item class="text-center">
            <el-button type="primary" @click="fn_submitActiveForm()" v-ladda>{{
              aLang.login_active
            }}</el-button>
          </el-form-item>
        </el-form>
        <a
          style="
            position: absolute;
            top: 0.5rem;
            right: 1rem;
            font-size: 1.5rem;
            cursor: pointer;
          "
          @click="fn_closeActiveForm"
        >
          <i class="el-icon-close"></i>
        </a>
      </div>
    </div>

    <!-- popup nhập mật khẩu -->
    <div
      v-show="mData.dataDefault.changePasswordVisible"
      style="
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 100;
      "
    >
      <div
        style="
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          background-color: rgba(56, 30, 30, 0.58);
        "
      ></div>
      <div
        style="
          width: calc(100% - 2rem);
          max-width: 445px;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          background-color: white;
          padding: 1rem;
          border-radius: 3px;
          box-shadow: 3px 6px 6px 0px rgba(0, 0, 0, 0.75);
        "
      >
        <h3>{{ aLang.login_change_password }}</h3>
        <b-alert
          variant="danger"
          dismissible
          :show="mData.dataDefault.showErrorChangePassword"
          @dismissed="mData.dataDefault.showErrorChangePassword = false"
          >{{ mData.dataDefault.errorChangePassword }}</b-alert
        >
        <el-form
          :model="mData.changePasswordForm"
          :rules="mData.validChangePasswordForm"
          ref="changePasswordForm"
          label-width="100%"
          label-position="top"
          @submit.native.prevent
        >
          <el-form-item :label="aLang.login_password" prop="password">
            <el-input
              prefix-icon="el-icon-unlock"
              v-model.trim="mData.changePasswordForm.password"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item :label="aLang.login_repassword" prop="rePassword">
            <el-input
              prefix-icon="el-icon-unlock"
              v-model.trim="mData.changePasswordForm.rePassword"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item class="text-center">
            <el-button
              type="primary"
              @click="fn_submitChangePasswordForm()"
              v-ladda
              native-type="submit"
              >{{ aLang.login_change_password }}</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import AuthService from "../../service/AuthService";
import LanguageService from "../../service/LanguageService";
import ValidService from "../../service/ValidService";
import MethodService from "../../service/MethodService";
import COSApi from "../../moduleApi/COSApi";
export default {
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(LanguageService.lang.valid_required));
      } else if (value !== this.mData.changePasswordForm.password) {
        callback(
          new Error(LanguageService.lang.c_changePasswordErrorReEnterNew)
        );
      } else {
        callback();
      }
    };
    return {
      aLang: LanguageService.lang,
      mData: {
        dataDefault: {
          error: "",
          showDismissibleAlert: false,
          isDoctor: false,
          activeVisible: false,
          errorActive: "",
          showErrorActive: false,
          disabledPhoneNumber: false,
          changePasswordVisible: false,
          errorChangePassword: "",
          showErrorChangePassword: false,
          oldPassword: "",
          actived: false,
          typeAccount: "",
          typeAccountUser: "1",
          TextPlaceHolder: "Nhập số thẻ khám chữa bệnh",
          TextErrorAccount: "Số thẻ khám chữa bệnh không đúng!",
          maxLengthAccountUser: 19,
        },
        dataForm: {
          account: "",
          accountFormat: "",
          peopleCode: "",
          password: "",
          remember: true,
        },
        validForm: {
          account: [ValidService.required],
          password: [ValidService.required],
        },
        activeForm: {
          phoneNumber: "",
          otp: "",
        },
        validActiveForm: {
          phoneNumber: [ValidService.required, ValidService.checkPhone],
          otp: [ValidService.required],
        },
        changePasswordForm: {
          password: "",
          rePassword: "",
        },
        validChangePasswordForm: {
          password: [ValidService.required, ValidService.checkPassword],
          rePassword: [
            ValidService.required,
            { validator: validatePass2, trigger: "blur" },
          ],
        },
        name: "",
      },
    };
  },
  methods: {
    async fn_submitForm() {
      this.mData.dataDefault.showDismissibleAlert = false;
      if (!this.mData.dataDefault.actived && !this.mData.dataDefault.isDoctor) {
        if (
          this.mData.dataForm.account !== "" &&
          this.mData.dataForm.account.includes("bs_") == false &&
          this.mData.dataForm.account != "admin"
        ) {
          let regex = /[0-9]/;
          if (!regex.test(this.mData.dataForm.account.trim())) {
            this.mData.dataDefault.showDismissibleAlert = true;
            this.mData.dataDefault.error = "Thông tin đăng nhập phải là số!";
            MethodService.stopLadda();
            return;
          }
          if (
            this.mData.dataDefault.typeAccountUser == "1" &&
            this.mData.dataForm.account.length != 16
          ) {
            this.mData.dataDefault.showDismissibleAlert = true;
            this.mData.dataDefault.error =
              "Số thẻ khám chữa bệnh phải là 16 số!";
            MethodService.stopLadda();
            return;
          }
          if (
            this.mData.dataDefault.typeAccountUser == "2" &&
            this.mData.dataForm.account.length != 9 &&
            this.mData.dataForm.account.length != 12
          ) {
            this.mData.dataDefault.showDismissibleAlert = true;
            this.mData.dataDefault.error = "Số CMND/CCCD phải là 9 hoặc 12 số!";
            MethodService.stopLadda();
            return;
          }
          if (
            this.mData.dataDefault.typeAccountUser == "3" &&
            this.mData.dataForm.account.length != 10
          ) {
            this.mData.dataDefault.showDismissibleAlert = true;
            this.mData.dataDefault.error = "Số điện thoại phải là 10 số!";
            MethodService.stopLadda();
            return;
          }
          if (
            this.mData.dataDefault.typeAccountUser == "4" &&
            this.mData.dataForm.account.length != 10
          ) {
            this.mData.dataDefault.showDismissibleAlert = true;
            this.mData.dataDefault.error = "Phải là 10 số cuối của thẻ BHYT!";
            MethodService.stopLadda();
            return;
          }
          let account = this.mData.dataForm.account;
          if (
            this.mData.dataDefault.typeAccountUser == 3 &&
            this.mData.dataForm.account.length == 10
          ) {
            account =
              "84" +
              this.mData.dataForm.account.substring(
                1,
                this.mData.dataForm.account.length
              );
          }
          let response = await COSApi.GetInfoUser(account);
          if (response.data && response.data.Data && response.data.Data[0]) {
            if (response.data && response.data.Data.length > 1) {
              this.fn_checkLoginPhone(response.data.Data);
              return;
            }
            if (response.data.Data[0].AvatarUrl) {
              let find = "\\\\";
              let re = new RegExp(find, "g");
              response.data.Data[0].AvatarUrl =
                response.data.Data[0].AvatarUrl.replace(re, "/");
            }
            if (response.data.Data[0].CmndBeforeUrl) {
              let find = "\\\\";
              let re = new RegExp(find, "g");
              response.data.Data[0].CmndBeforeUrl =
                response.data.Data[0].CmndBeforeUrl.replace(re, "/");
            }
            if (response.data.Data[0].CmndAfterUrl) {
              let find = "\\\\";
              let re = new RegExp(find, "g");
              response.data.Data[0].CmndAfterUrl =
                response.data.Data[0].CmndAfterUrl.replace(re, "/");
            }
            if (response.data.Data[0].FullName) {
              this.mData.name = response.data.Data[0].FullName;
            } else {
              this.mData.name = "";
            }
            let check = await AuthService.checkActive(
              response.data.Data[0].PeopleCode
                ? response.data.Data[0].PeopleCode
                : null
            );
            this.mData.dataForm.peopleCode = response.data.Data[0].PeopleCode;
            window.localStorage.setItem(
              "dataUser",
              JSON.stringify(response.data.Data[0])
            );
            if (!check) {
              this.mData.dataDefault.showDismissibleAlert = true;
              this.mData.dataDefault.error =
                LanguageService.lang.login_error_phone;
            } else {
              if (check.result) {
                this.mData.dataDefault.actived = true;
                this.mData.dataDefault.typeAccount = "victim";
                setTimeout(() => {
                  this.$refs["passwordInput"].focus();
                }, 100);
              } else if (
                check.meta &&
                check.meta.reason == "ACS_INVALID_CARD_CODE"
              ) {
                this.mData.dataDefault.showDismissibleAlert = true;
                this.mData.dataDefault.error =
                  LanguageService.lang.login_not_exist;
              } else {
                this.mData.dataDefault.activeVisible = true;
              }
            }
          } else {
            this.mData.dataDefault.showDismissibleAlert = true;
            this.fn_textErrorAccount();
            // this.mData.dataDefault.error =
            //   "Thông tin định danh không chính xác";
          }
          MethodService.stopLadda();
        } else if (
          this.mData.dataForm.account !== "" &&
          (this.mData.dataForm.account.includes("bs_") ||
            this.mData.dataForm.account == "admin")
        ) {
          if (this.mData.dataDefault.typeAccountUser !== "1") {
            this.mData.dataDefault.showDismissibleAlert = true;
            this.mData.dataDefault.error = "Thông tin đăng nhập phải là số!";
            MethodService.stopLadda();
            return;
          }
          this.mData.dataDefault.actived = true;
          this.mData.dataDefault.typeAccount = "doctor";
          MethodService.stopLadda();
        } else {
          this.$refs["myForm"].validateField("account");
          MethodService.stopLadda();
        }
      } else {
        this.$refs["myForm"].validate(async (valid) => {
          if (valid) {
            if (this.mData.dataDefault.isDoctor) {
              AuthService.loginBs(
                this.mData.dataForm.account,
                this.mData.dataForm.password,
                this.mData.dataForm.remember
              )
                .then((res) => {
                  this.$router.push({ name: "Admin-Home" });
                })
                .catch((error) => {
                  console.log(error);
                  this.mData.dataDefault.showDismissibleAlert = true;
                  this.mData.dataDefault.error =
                    LanguageService.lang.login_error;
                });
            } else if (this.mData.dataDefault.actived) {
              if (this.mData.dataDefault.typeAccount == "hospital") {
                let res_login = await AuthService.login(
                  "tichhop",
                  "tichhop",
                  false
                );
                if (res_login.result && res_login.result.token) {
                  window.localStorage.setItem("token", res_login.result.token);
                }
                AuthService.login(
                  this.mData.dataForm.account,
                  this.mData.dataForm.password,
                  this.mData.dataForm.remember
                )
                  .then((res) => {
                    if (window.localStorage.routerHistory) {
                      var routerHistory = JSON.parse(
                        window.localStorage.routerHistory
                      );
                      if (
                        routerHistory &&
                        routerHistory.name == "Admin-hssk831-details" &&
                        routerHistory.query &&
                        routerHistory.query.cardCode &&
                        routerHistory.query.role
                      ) {
                        this.$router.push({
                          name: "Admin-hssk831-details",
                          query: routerHistory.query,
                        });
                      } else if (
                        routerHistory &&
                        routerHistory.name == "Admin-hsskHL7" &&
                        routerHistory.query &&
                        routerHistory.query.cardCode
                      ) {
                        this.$router.push({
                          name: "Admin-hsskHL7",
                          query: {
                            cardCode: routerHistory.query.cardCode,
                          },
                        });
                      } else {
                        this.$router.push({ name: "Admin-Home" });
                      }
                    } else {
                      this.$router.push({ name: "Admin-Home" });
                    }
                  })
                  .catch((error) => {
                    this.mData.dataDefault.showDismissibleAlert = true;
                    this.mData.dataDefault.error =
                      LanguageService.lang.login_error;
                  });
              } else {
                if (window.localStorage.getItem("token")) {
                  window.localStorage.removeItem("token");
                }
                if (this.mData.dataDefault.typeAccount == "doctor") {
                  AuthService.loginOnelink(
                    this.mData.dataForm.account,
                    this.mData.dataForm.password,
                    this.mData.dataForm.remember
                  )
                    .then((res) => {
                      if (window.localStorage.routerHistory) {
                        var routerHistory = JSON.parse(
                          window.localStorage.routerHistory
                        );
                        if (
                          routerHistory &&
                          routerHistory.name == "Admin-hssk831-details" &&
                          routerHistory.query &&
                          routerHistory.query.cardCode &&
                          routerHistory.query.role
                        ) {
                          this.$router.push({
                            name: "Admin-hssk831-details",
                            query: routerHistory.query,
                          });
                        } else if (
                          routerHistory &&
                          routerHistory.name == "Admin-hsskHL7" &&
                          routerHistory.query &&
                          routerHistory.query.cardCode
                        ) {
                          this.$router.push({
                            name: "Admin-hsskHL7",
                            query: {
                              cardCode: routerHistory.query.cardCode,
                            },
                          });
                        } else {
                          this.$router.push({ name: "Admin-Home" });
                        }
                      } else {
                        this.$router.push({ name: "Admin-Home" });
                      }
                    })
                    .catch((error) => {
                      this.mData.dataDefault.showDismissibleAlert = true;
                      this.mData.dataDefault.error =
                        LanguageService.lang.login_error;
                    });
                }

                if (this.mData.dataDefault.typeAccount == "victim") {
                  AuthService.login_v2(
                    this.mData.dataForm.peopleCode,
                    this.mData.dataForm.password,
                    this.mData.dataForm.account,
                    this.mData.dataForm.remember
                  )
                    .then((res) => {
                      window.localStorage.setItem(
                        "account",
                        this.mData.dataForm.account
                      );
                      if (window.localStorage.routerHistory) {
                        var routerHistory = JSON.parse(
                          window.localStorage.routerHistory
                        );
                        if (
                          routerHistory &&
                          routerHistory.name == "Admin-hssk831-details" &&
                          routerHistory.query &&
                          routerHistory.query.cardCode &&
                          routerHistory.query.role
                        ) {
                          this.$router.push({
                            name: "Admin-hssk831-details",
                            query: routerHistory.query,
                          });
                        } else if (
                          routerHistory &&
                          routerHistory.name == "Admin-hsskHL7" &&
                          routerHistory.query &&
                          routerHistory.query.cardCode
                        ) {
                          this.$router.push({
                            name: "Admin-hsskHL7",
                            query: {
                              cardCode: routerHistory.query.cardCode,
                            },
                          });
                        } else {
                          this.$router.push({ name: "Admin-Home" });
                        }
                      } else {
                        this.$router.push({ name: "Admin-Home" });
                      }
                    })
                    .catch((error) => {
                      this.mData.dataDefault.showDismissibleAlert = true;
                      this.mData.dataDefault.error =
                        LanguageService.lang.login_error;
                    });
                }
              }
              //
            }
          } else {
            MethodService.stopLadda();
            return false;
          }
        });
      }
    },
    fn_changeTypeAccountUser() {
      let validate;
      if (this.mData.dataDefault.typeAccountUser == "1") {
        validate = 19;
      } else if (this.mData.dataDefault.typeAccountUser == "2") {
        validate = 12;
      } else if (this.mData.dataDefault.typeAccountUser == "3") {
        validate = 10;
      } else if (this.mData.dataDefault.typeAccountUser == "4") {
        validate = 12;
      }
      this.mData.dataDefault.actived = false;
      this.mData.dataDefault.maxLengthAccountUser = validate;
      this.mData.dataForm.account = "";
      this.mData.dataForm.accountFormat = "";
      this.fn_setTextPlaceHolder();
      setTimeout(() => {
        this.$refs["accountInput"].focus();
      }, 100);
    },
    fn_checkLoginPhone(listInforUser) {
      let cache = listInforUser.filter((e) => {
        return e.IsLoginByPhone == true;
      });
      if (cache.length == 0) {
        this.mData.dataDefault.showDismissibleAlert = true;
        this.mData.dataDefault.error =
          "Số điện thoại này đã đăng ký nhiều hơn một tài khoản, vui lòng liên hệ tổng đài 19006888 để được hướng dẫn!";
      }
    },
    fn_setTextPlaceHolder() {
      let TextPlaceHolder = "";
      switch (this.mData.dataDefault.typeAccountUser) {
        case "1":
          TextPlaceHolder = "Nhập số thẻ khám chữa bệnh";
          break;
        case "2":
          TextPlaceHolder = "Nhập số CMND/CCCD";
          break;
        case "3":
          TextPlaceHolder = "Nhập số điện thoại di động";
          break;
        case "4":
          TextPlaceHolder = "Nhập 10 số cuối BHYT";
          break;
        default:
          break;
      }
      this.mData.dataDefault.TextPlaceHolder = TextPlaceHolder;
    },
    fn_textErrorAccount() {
      let TextErrorAccount = "";
      switch (this.mData.dataDefault.typeAccountUser) {
        case "1":
          TextErrorAccount = "Số thẻ khám chữa bệnh không đúng!";
          break;
        case "2":
          TextErrorAccount = "Số CMND/CCCD không đúng!";
          break;
        case "3":
          TextErrorAccount = "Số điện thoại không đúng!";
          break;
        case "4":
          TextErrorAccount = "10 số cuối số thẻ BHYT không đúng!";
          break;
        default:
          break;
      }
      this.mData.dataDefault.error = TextErrorAccount;
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
      this.mData.dataDefault.actived = false;
      if (!this.mData.dataDefault.isDoctor) {
        console.log("có vào nha");
        this.mData.dataDefault.typeAccountUser = "1";
        this.mData.dataForm.accountFormat = "";
        this.mData.dataDefault.maxLengthAccountUser = 19;
        this.mData.dataDefault.TextPlaceHolder = "Nhập số thẻ khám chữa bệnh";
      } else {
        this.mData.dataForm.accountFormat = "";
        this.mData.dataForm.account = "";
      }
      setTimeout(() => {
        this.$refs["accountInput"].focus();
      }, 100);
    },
    fn_getOTP() {
      if (this.mData.activeForm.phoneNumber == "") {
        this.$refs["activeForm"].validateField("phoneNumber");
        MethodService.stopLadda();
        return false;
      } else if (
        ValidService.checkPhone.pattern.test(
          this.mData.activeForm.phoneNumber
        ) == false
      ) {
        this.$refs["activeForm"].validateField("phoneNumber");
        MethodService.stopLadda();
        return false;
      } else {
        AuthService.requestActiveCode(
          this.mData.dataForm.peopleCode,
          "84" + this.mData.activeForm.phoneNumber.substring(1)
        )
          .then((res) => {
            if (res.result) {
              this.mData.dataDefault.disabledPhoneNumber = true;
              this.$message({
                showClose: true,
                message: LanguageService.lang.login_sent_otp,
                type: "success",
              });
            } else {
              this.mData.dataDefault.errorActive =
                LanguageService.lang.login_error_active_phone;
              this.mData.dataDefault.showErrorActive = true;
            }
          })
          .catch((err) => {
            console.log(err);
            this.mData.dataDefault.errorActive =
              LanguageService.lang.login_error_phone;
            this.mData.dataDefault.showErrorActive = true;
          });
        MethodService.stopLadda();
      }
    },
    fn_submitActiveForm() {
      this.$refs["activeForm"].validate((valid) => {
        if (valid) {
          let passwordRandom = Math.random().toString();
          AuthService.ActiveAccount(
            this.mData.dataForm.peopleCode,
            this.mData.activeForm.otp,
            passwordRandom
          )
            .then((res) => {
              if (res.result) {
                AuthService.login_v2(
                  this.mData.dataForm.peopleCode,
                  passwordRandom,
                  this.mData.dataForm.account,
                  true
                )
                  .then((res) => {
                    this.mData.dataDefault.oldPassword = passwordRandom;
                    this.mData.dataDefault.changePasswordVisible = true;
                    this.mData.dataDefault.activeVisible = false;
                  })
                  .catch((error) => {
                    console.log(error);
                    this.mData.dataDefault.errorActive =
                      LanguageService.lang.login_error_phone;
                    this.mData.dataDefault.showErrorActive = true;
                  });
              } else {
                this.mData.dataDefault.errorActive =
                  LanguageService.lang.login_error_active;
                this.mData.dataDefault.showErrorActive = true;
              }
              MethodService.stopLadda();
            })
            .catch((error) => {
              this.mData.dataDefault.errorActive =
                LanguageService.lang.login_error_phone;
              this.mData.dataDefault.showErrorActive = true;
              MethodService.stopLadda();
            });
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_submitChangePasswordForm() {
      this.$refs["changePasswordForm"].validate((valid) => {
        if (valid) {
          AuthService.changePassword(
            this.mData.dataForm.peopleCode,
            this.mData.dataDefault.oldPassword,
            this.mData.changePasswordForm.password
          )
            .then((res) => {
              AuthService.login_v2(
                this.mData.dataForm.peopleCode,
                this.mData.changePasswordForm.password,
                this.mData.dataForm.account,
                this.mData.dataForm.remember
              )
                .then((res) => {
                  window.localStorage.setItem(
                    "account",
                    this.mData.dataForm.account
                  );
                  if (window.localStorage.routerHistory) {
                    var routerHistory = JSON.parse(
                      window.localStorage.routerHistory
                    );
                    if (
                      routerHistory &&
                      routerHistory.name == "Admin-hssk4210" &&
                      routerHistory.query &&
                      routerHistory.query.cardCode
                    ) {
                      this.$router.push({
                        name: "Admin-hssk4210",
                        query: {
                          cardCode: routerHistory.query.cardCode,
                        },
                      });
                    } else if (
                      routerHistory &&
                      routerHistory.name == "Admin-hsskHL7" &&
                      routerHistory.query &&
                      routerHistory.query.cardCode
                    ) {
                      this.$router.push({
                        name: "Admin-hsskHL7",
                        query: {
                          cardCode: routerHistory.query.cardCode,
                        },
                      });
                    } else {
                      this.$router.push({ name: "Admin-Home" });
                    }
                  } else {
                    this.$router.push({ name: "Admin-Home" });
                  }
                })
                .catch((error) => {
                  console.log(error);
                  this.mData.dataDefault.showErrorChangePassword = true;
                  this.mData.dataDefault.errorChangePassword =
                    LanguageService.lang.login_error;
                });
            })
            .catch((error) => {
              this.mData.dataDefault.errorChangePassword =
                LanguageService.lang.login_error_phone;
              this.mData.dataDefault.showErrorChangePassword = true;
              MethodService.stopLadda();
            });
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_changeAccount() {
      this.mData.dataDefault.actived = false;
      this.mData.dataDefault.showDismissibleAlert = false;
      this.mData.name = "";
      this.$refs["myForm"].resetFields();
      this.mData.dataForm.accountFormat = "";
      setTimeout(() => {
        this.$refs["accountInput"].focus();
      }, 100);
    },
    fn_changeData(form, field) {
      console.log("vào changeData");
      this.$refs[form].validateField(field);
    },
    fn_changeDataAccountUser() {
      if (!this.mData.dataDefault.isDoctor) {
        let valreal = this.mData.dataForm.accountFormat.replace(/\s/g, "");
        let IdFormat = valreal;

        if (this.mData.dataDefault.typeAccountUser == "1") {
          IdFormat =
            this.mData.dataForm.accountFormat.length > 4
              ? this.fn_formatNumber(valreal)
              : valreal;
        } else if (this.mData.dataDefault.typeAccountUser == "4") {
          IdFormat =
            this.mData.dataForm.accountFormat.length > 3
              ? this.fn_formatNumberBHYT(valreal)
              : valreal;
        }
        this.mData.dataForm.accountFormat = IdFormat;
        this.mData.dataForm.account = valreal;
      } else {
        this.mData.dataForm.account = this.mData.dataForm.accountFormat;
      }
    },
    fn_formatNumber(num) {
      return num.toString().replace(/(\d{4})(?=\d)/g, "$1 ");
    },
    fn_formatNumberBHYT(num) {
      // return num.toString().replace(/(\d{3})(?=\d)/g, '$1 ');
      if (num.length > 6) {
        return `${num.substring(0, 3)} ${num.substring(3, 6)} ${num.substring(
          6,
          num.length
        )}`;
      } else if (num.length > 3) {
        return `${num.substring(0, 3)} ${num.substring(3, num.length)}`;
      }
    },
    fn_closeActiveForm() {
      this.$refs["activeForm"].resetFields();
      this.mData.dataDefault.disabledPhoneNumber = false;
      this.mData.dataDefault.activeVisible =
        !this.mData.dataDefault.activeVisible;
      this.mData.dataDefault.showErrorActive = false;
    },
    fn_forgotPassword() {
      this.$router.push({
        name: "Auth-ForgotPassword",
        query: {
          account: this.mData.dataForm.account,
          peopleCode: this.mData.dataForm.peopleCode,
        },
      });
    },
  },
  mounted: function () {
    if (window.localStorage.getItem("routerHistory")) {
      let routerHistory = JSON.parse(
        window.localStorage.getItem("routerHistory")
      );
      if (
        routerHistory.name &&
        routerHistory.name == "Admin-hssk831-details" &&
        routerHistory.query &&
        routerHistory.query.role &&
        routerHistory.query.role == "hospital"
      ) {
        this.mData.dataDefault.actived = true;
        this.mData.dataDefault.typeAccount = "hospital";
      }
    }
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-input {
  input {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

::v-deep .el-radio__label {
  font-size: 15px !important;
}

::v-deep .el-input__inner {
  font-size: 14px;
}
</style>
